import { z } from 'zod';

/**
 * Device settings document (camelCase).
 *
 * Stored per-install in local storage; does NOT follow the user to another
 * device or survive reinstall. Structurally symmetric to the account document:
 * a single camelCase JSON blob validated by a Zod schema whose every field has
 * a `.default()`, so `.parse({})` yields a fully-populated document.
 *
 * First inhabitant: `reduceMotion` (stored now; may be respected later).
 */
export const DeviceSettingsSchema = z.object({
  reduceMotion: z.boolean().default(false),
  schemaVersion: z.number().default(1),
});

export type DeviceSettings = z.infer<typeof DeviceSettingsSchema>;
